import styled from 'styled-components'

export const MagicalButton = styled.a`
  color: #fff;
  text-decoration: none;
  padding: 0.9rem 1.4rem;
  background: #38d39f;
  border-radius: 0.3rem;
  transition: 0.5s;

  @media (max-width: 380px) {
    width: 80%;
    margin: 0 auto;
    text-align: center;
  }

  &:hover {
    box-shadow: 0px 0px 17px 0px rgba(0, 196, 255, 0.36);
    transition: 0.5s;
  }

  &:first-child {
    margin-right: 1rem;
    background: #f9f9f9;
    color: #38d39f;

    &:hover {
      box-shadow: 0px 0px 17px 0px rgba(185, 185, 185, 0.4);
    }

    @media (max-width: 380px) {
      margin: 0 auto 1.5rem auto;
    }
  }
`

export const Wrapper = styled.div`
	display: flex;
  align-items: center;
  justify-content: space-between;
	padding: 4rem 0rem 4rem 4rem;

  p {
    color: gray;
    margin-bottom: 4rem;
  }
  
  @media (max-width: 960px) {
    flex-direction: column;
    padding: 3rem 0.5rem;
  }

  ${({ theme }) =>
    theme === 'dark' &&
    `
			color: #fff;
	`}
`

export const FlexOne = styled.div`
	flex: 1;
	
	
	
  @media (max-width: 390px) {
  
    h1 { 
		padding-left: 2rem; 
		}
	
		p {
		padding-left: 2rem;
		}
		
  }
	
 	@media (max-width: 960px) {
		width: 100%;
		margin-bottom: 4rem;
	}	

`

export const Thumbnail = styled.div`
  flex: 1;

  @media (max-width: 960px) {
    width: 100%;
    padding-left: 2rem;
  }

  img {
    width: 100%;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 380px) {
    flex-direction: column;
  }
`